import { useEffect } from 'react';

const SITE = 'Desi Bites NWA';
const BASE_URL = 'https://desibitesnwa.com';

function upsertMeta(key, keyType, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${keyType}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(keyType, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/**
 * useSeo — lightweight per-page SEO for this client-rendered (CRA) app.
 *
 * Sets document.title, meta description, canonical link, and OG/Twitter
 * title+description on mount. This is picked up by JS-rendering crawlers
 * (e.g. Googlebot). Sitewide defaults + JSON-LD live in public/index.html.
 *
 * @param {{ title?: string, description?: string, path?: string }} opts
 */
export default function useSeo({ title, description, path } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} — Authentic Indian Food`;
    document.title = fullTitle;

    upsertMeta('description', 'name', description);
    upsertMeta('og:title', 'property', fullTitle);
    upsertMeta('og:description', 'property', description);
    upsertMeta('twitter:title', 'name', fullTitle);
    upsertMeta('twitter:description', 'name', description);

    if (path != null) {
      const url = `${BASE_URL}${path}`;
      upsertMeta('og:url', 'property', url);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', url);
    }
  }, [title, description, path]);
}
